import { render, staticRenderFns } from "./GridItem.vue?vue&type=template&id=836f9e34&scoped=true"
import script from "./GridItem.vue?vue&type=script&lang=js"
export * from "./GridItem.vue?vue&type=script&lang=js"
import style0 from "./GridItem.vue?vue&type=style&index=0&id=836f9e34&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836f9e34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('836f9e34')) {
      api.createRecord('836f9e34', component.options)
    } else {
      api.reload('836f9e34', component.options)
    }
    module.hot.accept("./GridItem.vue?vue&type=template&id=836f9e34&scoped=true", function () {
      api.rerender('836f9e34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/browser/GridItem.vue"
export default component.exports